module.exports = (window.__NEXT_DATA__.assetPrefix || "").replace(/\/$/, "") + "/_next/static/images/favicon-3888b0e329526a975703e3059a02b92d.ico";